export default {
  "header.language": "언어",
  "Log in": "로그인",
  "Sign Up": "회원가입",
  "Buy Crypto": "코인 구매",
  "header.quicktrade": "Quick 코인 구매",
  "header.quicktrade.desc": "신용카드로 코인을 빠르게 매매",
  "header.C2C": "P2P 거래",
  "header.C2C.desc": "간단한 조작, 빠른 거래, 거래의 첫 걸음",
  "header.u.account": "계정 관리",
  "header.u.fee": "수수료 기준",
  "header.u.bonus": "내 증정금",
  "header.u.c2c": "P2P 설정",
  "header.u.invite": "친구 초대",
  "header.u.api": "API 관리",
  "header.u.logout": "로그아웃",
  "header.rate": "환율",
  Market: "시세",
  Spot: "현물 거래",
  Futures: "선물 거래",
  koltrade: "카피 트레이딩",
  Bonus: "증정금 센터",
  Agent: "글로벌 파트너",
  more: "더 보기",
  "Perpetual Contract": "무기한",
  "header.assets": "자산",
  "header.order": "주문",
  totalAssets: "자산 개요",
  exchangeAccount: "현물 계좌",
  otcAccount: "P2P 계좌",
  coAccount: "선물 계좌",
  exchangeOrder: "현물 주문",
  otcOrder: "P2P 주문",
  coOrder: "선물 주문",
  "header.appDownLoad": "스캔하여 앱 다운로드",
  "header.moreload": "더 많은 다운로드 옵션",
  "index.banner.2": "당신을 가장 잘 이해하는 AI 스마트 거래소",
  "Register Now": "지금 등록하기",
  "Trade Now": "지금 거래하기",
  "index.register.type": "이메일/휴대폰 번호",
  "index.banner.desc": "가입하여 최대 {amount}의 미션 보상 받기",
  "index.text1": "탁월한",
  "index.text2": "현물 유동성",
  "index.text3": "선물 유동성",
  "index.text4": "스프레드 > Spread",
  "index.text5": "유동성 깊이",
  "index.text6": "업계 순위",
  "index.c4.title": "전문적이고 간편한 사용 방식",
  "index.c4.title2": "VOOX는 모든 사용자를 위한 암호화폐 플랫폼을 제공합니다",
  "index.c4.t1.t": "현물 거래",
  "index.c4.t1.p":
    "BTC, ETH, USDT와 같은 주요 암호화폐를 깊은 유동성과 빠른 실행으로 거래하세요",
  "index.c4.t2.t": "선물 거래",
  "index.c4.t2.p": "유연한 레버리지 선물 거래로 거래 잠재력을 높이세요",
  "index.c4.t3.t": "카피 트레이딩",
  "index.c4.t3.p":
    "최고의 트레이더를 팔로우하여, 시장 동향을 추적하고, 전략을 쉽게 최적화하세요",
  "index.c5.title": "VOOX에서 쉽게 수익을 창출하세요",
  "index.c5.title2":
    "VOOX의 직관적인 플랫폼에서 암호화폐 거래의 힘을 발휘하세요",
  "index.c5.t1.t": "VOOX에서 무비용 선물 거래를 경험하세요",
  "index.c5.t1.p":
    "풍부한 보너스 이벤트를 통해 선물 거래를 빠르게 익히고 쉽게 수익을 올리세요",
  "index.c5.t2.t": "전문가와 함께 지능적으로 수익 창출",
  "index.c5.t2.p":
    "최첨단 카피 트레이딩 플랫폼이 당신을 최고의 트레이더와 연결합니다. 위임만 하면 쉽게 수익을 올릴 수 있습니다",
  "index.c6.title": "최고의 안전",
  "index.c6.title2": "VOOX는 24시간 고객 자산을 보호합니다",
  "index.c6.1.t": "전면감사",
  "index.c6.1.p":
    "VOOX는 철저한 감사를 수행하여 플랫폼의 무결성과 안전성을 보장하며, 모든 거래가 투명하고 신뢰할 수 있도록 합니다",
  "index.c6.2.t": "암호화 자산 보관 파트너십",
  "index.c6.2.p":
    "VOOX는 최고의 암호화 자산 보관사와 협력하여 사용자 자산의 안전성을 강화합니다. 우리의 파트너십은 최고의 보안 기준과 자산 보호에 대한 약속을 기반으로 합니다",
  "index.c6.3.t": "안전한 콜드 스토리지",
  "index.c6.3.p":
    "VOOX는 안전한 콜드 스토리지 솔루션을 사용하여 디지털 자산을 보호하며, 리스크를 최소화하고 자금을 무단 접근으로부터 보호합니다",
  "index.c6.4.t": "합법적이고 규정 준수",
  "index.c6.4.p":
    "VOOX는 법률 및 규제 기준을 엄격히 준수하여 모든 운영이 합법적이고 규정을 따르도록 하며, 사용자에게 안전한 거래 환경을 제공합니다",
  "c7.title": "원활한 거래 경험",
  "c7.title2":
    "언제 어디서나 편하고 쉽게 VOOX 플랫폼을 통해 글로벌 암호화폐 시장을 경험해보세요",
  c7_qrcode: "스캔하여 앱 다운로드",
  c7_qrcode1: "VOOX Android/IOS 앱 다운로드",
  "c8.title": "당신의 암호화폐 여정을 시작하세요",
  "c8.title2":
    "VOOX의 AI 기반 인사이트로 더 똑똑하게 거래하고, 더 많은 수익을 올리세요",
  "footer.contractus": "문의하기",
  "footer.media": "커뮤니티 및 소셜 미디어",
  "footer.downloadapp": "앱 다운로드",
  "footer.product": "제품",
  "footer.creditCardPurchase": "신속하게 코인 구매",
  "footer.c2c": "P2P",
  "footer.trade": "현물 거래",
  "footer.futures": "선물 거래",
  "footer.futures": "선물 거래",
  "footer.koltrade": "퓨처 카피 트레이딩",
  "footer.bonus": "증정금 센터",
  "footer.business": "비즈니스",
  "footer.cms.apply": "리스팅 신청",
  "footer.agent.apply": "파트너 신청",
  "footer.c2c.apply": "C2C 상인 신청",
  "footer.support": "지원",
  "footer.mesage": "공지 센터",
  "footer.help": "도움말 센터",
  "footer.fee": "수수료 센터",
  "footer.about": "회사 소개",
  "footer.agreement": "이용 약관",
  "footer.privacy": "개인정보 보호정책",
  "footer.disclaimer": "AML 정책",
  "footer.companyname": "회사명: VOOX Limited",
  "footer.companynumber": "회사 등록 번호: 20241849145",
  "footer.companyaddress":
    "회사 주소: 1312 17th Street, Unit Num 2955, Denver, CO 80202, United States",
  "footer.customerService": "고객 서비스 센터",
  "footer.online_custom": "고객센터",
  "footer.requests": "문의 등록",
  Notice: "공지",
};
